import IntegrationDetail from './integrationDetail.container';

export default IntegrationDetail;
